import React, { useEffect } from 'react';
import { motion, useMotionValue, useTransform, animate } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const DataAnimation = ({ data }) => {

  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const animationCount = data.Animations.length;
  let gridColumns = 'grid-cols-1';

  if (animationCount === 2) {
    gridColumns = 'grid-cols-1 sm:grid-cols-2';
  } else if (animationCount > 2) {
    gridColumns = 'grid-cols-1 sm:grid-cols-2';
  }

  const hasLayoutChange = data.DataAnimationLayout && data.DataAnimationLayout.startsWith('Vertical');
  const hasMultipleAnimations = data.Animations && data.Animations.length > 1;
  const hasThreeCols = data.DataAnimationCols && data.DataAnimationCols.startsWith('Three');

  const isGerman = typeof window !== 'undefined' && window.location.pathname.includes('/de/');

  const animatedDecimal = (initialValue, decimalPlaces) => {
    const count = useMotionValue(0 || 0); // Set initial value to 0 if empty or null

    useEffect(() => {
      if (inView) {
        const animation = animate(count, initialValue, {
          duration: 1,
          delay: 0.3,
        });
        return animation.stop;
      }
    }, [inView]);

    const formattedDecimal = useTransform(count, (value) => {
      const decimalDivider = isGerman ? ',' : '.';
      const formattedValue = value.toLocaleString(decimalPlaces).replace(',', decimalDivider);
      return formattedValue;
    });

    return formattedDecimal;
  };

  return (
    <article className="container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl mb-16 md:mb-24 lg:mb-32 xl:mb-48 px-4 md:px-24 xl:px-24" ref={ref}>
      {data.Text && (
        <motion.div
          className="text-center"
          initial="invisible"
          animate={inView ? 'visible' : 'invisible'}
          className="richtextdatanimation mb-12 md:mb-24"
        >
          <div dangerouslySetInnerHTML={{ __html: data.Text }} />
        </motion.div>
      )}
      {hasLayoutChange ? (
        <div className={`grid grid-cols-1 w-full`}>
          {data.Animations.map((animation, index) => {
            const formattedNumber = animatedDecimal(animation.DataAniumber, animation.DecimalPlaces);

            return (
              <React.Fragment key={index}>
                <div className="col-span-1 text-center px-16">
                  <div className="number">
                    <h2>
                      <motion.span>{formattedNumber}</motion.span>&nbsp;
                      {animation.NumberUnit}
                    </h2>
                  </div>
                  <div className="text mt-4">
                    <p className="mb-0 max-w-sm mx-auto text-text tracking-text-sm leading-text-sm px-12 md:px-0">
                      {animation.NumberDescription}
                    </p>
                  </div>
                </div>
                {hasMultipleAnimations && index !== data.Animations.length - 1 && (
                  <div className="flex items-center justify-center">
                    <div className="line w-[4px] h-32 bg-black mt-12 mb-12" />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      ) : (
        <div className={`flex flex-row flex-wrap gap-y-12`}>
          {data.Animations.map((animation, index) => {
            const formattedNumber = animatedDecimal(animation.DataAniumber, animation.DecimalPlaces);

            return (
              <React.Fragment key={index}>
                <div className={`${hasThreeCols ? "basis-4/12" : "basis-6/12"} grow text-center ${hasThreeCols ? "px-16 sm:px-16 md:px-8" : "px-4 sm:px-16 md:px-24"}`}>
                  <div className="number">
                    <h2>
                      <motion.span>{formattedNumber}</motion.span>&nbsp;
                      {animation.NumberUnit}
                    </h2>
                  </div>
                  <div className="text mt-4">
                    <p className="mb-0 max-w-sm mx-auto text-text tracking-text leading-text-sm px-12 md:px-12">
                      {animation.NumberDescription}
                    </p>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      )}
    </article>
  );
};

export default DataAnimation;
